import dataManager from '../main/datamanager';
import net from "../../loader/lib/net";
import config from './dao_config'
import util from '../../loader/utils/util'
import appUtil from '../lib/appUtil'
var constants = {}
import tips from '../../loader/widget/tips'
import { router } from '../../loader/lib/router'

//数据获取
var manager = {

    /**
     * 获取登录信息
     */
    checkLogin: function (cb, fail, global) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        global = (global == undefined) ? false : global;

        net.send(config.get('checkLogin'), {
            cb: _cb,
            global: global
        });
    },

    /**
     * 注销
     */
    quitLogin: function (cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('quitLogin'), {
            cb: _cb
        });
    },

    /**
     * 查询区域列表
     */
    queryRegion: function (cb, fail, dateManageKey) {
        dateManageKey || (dateManageKey = 'region_list');
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail, dateManageKey);
            };

        if (dataManager.get(dateManageKey)) {
            cb(dataManager.get(dateManageKey));
        } else {
            net.send(config.get('queryRegion'), {
                cb: _cb
            });
        }
    },

    /**
     * 查询黑石支持地域
     * @param cb
     * @param fail
     */
    queryBmRegion: function (cb, fail) {
        var key = 'bm_region_list'
        var data = dataManager.get(key)
        if (data) {
            cb(data)
        } else {
            //北京地域是黑石第一个支持的地域, 所以从北京查询
            this.delegateCApi(8, 'bm', 'DescribeRegions', {}, function (data) {
                dataManager.set(key, data)
                cb(data)
            }, fail)
        }
    },

    /**
     * 查询openid openkey
     */
    queryCorpRedirect: function (cb, fail, dateManageKey) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail, dateManageKey);
            };
        net.send(config.get('queryCorpRedirect'), {
            cb: _cb
        });
    },

    /**
     * 查询OS列表
     */
    queryOs: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('queryOs'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 查询cdn菜单
     */
    queryCdnMenu: function (cb, fail) {
        var _self = this;
        var cdnDomain = 'cdn.' + document.domain;
        $.ajax({
            type: "get",
            url: '//' + cdnDomain + '/ajax/api.php?action=get_menu&format=jsonp&g_tk=' + util.getACSRFToken(),
            dataType: "jsonp",
            jsonp: 'cb',
            success: function (ret) {
                var data = {};
                if (ret && ret.data) {
                    data = ret.data;
                }
                cb(data);
            }
        });
    },
    /**
     * 查询云支付菜单
     */
    queryCpayMenu: function (cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('queryCpayMenu'), {
            cb: _cb
        });
    },

    /**
     * 查询cns菜单
     */
    queryCnsMenu: function (cb, fail) {
        var _self = this;
        var host = 'wss.qcloud.com';

        $.ajax({
            type: "get",
            url: '//' + host + '/dns/api/config/get_menu?mc_gtk=' + util.getACSRFToken(),
            dataType: "jsonp",
            jsonp: 'cb',
            success: function (ret) {
                var data = {};
                if (ret) {
                    data = ret;
                }
                cb(data);
            }
        });
    },

    /**
     * 查询ovm菜单
     */
    queryOvmMenu: function (cb, fail) {
        var _self = this;

        $.ajax({
            url: '//ovm.qcloud.com/gamecloud_ovm/app_menu/GetMenu',
            dataType: "jsonp",
            jsonp: 'cb',
            success: function (ret) {
                var data = {};
                if (ret) {
                    data = ret;
                }
                cb(data);
            }
        });
    },

    /**
     * 查询大禹菜单
     */
    queryDayuMenu: function (cb) {
        var _self = this;
        $.ajax({
            type: "get",
            url: '//dy.qcloud.com/ajax/api.php?action=get_menu&format=jsonp&g_tk=' + util.getACSRFToken(),
            dataType: "jsonp",
            jsonp: 'cb',
            success: function (ret) {
                var data = {};
                if (ret && ret.data) {
                    data = ret.data;
                }
                cb(data);
            }
        });
    },

    /**
     * 查询云搜菜单
     */
    queryYunsoMenu: function (cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('queryYunsoMenu'), {
            cb: _cb
        });
    },

    /**
     * 查询文智菜单
     */
    queryWenzhiMenu: function (cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('queryWenzhiMenu'), {
            cb: _cb
        });
    },

    /**
     * 查询云监控菜单
     */
    queryMonitorMenu: function (cb, fail) {
        var _cb = function (ret) {
            dataManager.commonCb(ret, cb, fail);
        };
        $.ajax({
            url: '//monitor.' + QCCONSOLE_HOST.substr(8) + '/index.php/nav/list',
            dataType: 'jsonp',
            data: {
                _format: 'json'
            },
            jsonp: 'cb',
            success: _cb,
            error: fail
        });
    },

    /**
     * 查询「机智」子菜单
     * */
    queryTmlMenu: function (cb, fail) {
        var _cb = function (ret) {
            dataManager.commonCb(ret, cb, fail);
        };
        $.ajax({
            url: '//tml.qcloud.com/ajax/get_menu',
            dataType: 'jsonp',
            jsonp: 'cb',
            data: {
                _format: 'json'
            },
            success: _cb,
            error: fail
        });
    },

    /**
     * 查询 cos 菜单
     */
    queryCosMenu: function (cb, fail) {
        var _cb = function (ret) {
            dataManager.commonCb(ret, cb, fail);
        };
        $.ajax({
            url: 'https://cosapi.qcloud.com/api.php',
            dataType: 'jsonp',
            jsonp: 'callback',
            data: {
                Action: 'GetMenu',
                mc_gtk: util.getACSRFToken()
            },
            success: _cb,
            error: fail
        });
    },

    /**
     * 获取项目列表
     */
    getProjects: function (cb, fail) {
        this.getComData(function (comData) {
            var grantInfo = comData.userInfo.grantInfo;
            var allowServiceList = grantInfo && grantInfo.allowServiceList || [];
            var serviceName = router.fragment && router.fragment.split('/')[1];
            // CAM 定义的业务级授权直接返回所有项目
            if (serviceName && allowServiceList.indexOf(serviceName) > -1 && grantInfo.projectList) {
                cb({
                    isShowAll: true,
                    data: grantInfo.projectList
                });
                return;
            }
            // 默认逻辑，返回有权限的项目列表
            cb({
                isShowAll: comData.isShowAllProject,
                data: comData.projects
            })
        })
    },

    /**
     * 获取用户所在区域（国内/海外）
     */
    getUserAreaInfo: function (cb, fail) {
        this.getComData(function (comData) {
            cb(comData.userInfo.areaInfo);
        });
    },

    /**
     * 查询白名单
     * @param {Array} data.whiteKey 白名单key
     */
    queryWhiteList: function (data, cb, fail, global) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('queryWhiteList'), {
            data: data,
            global: global,
            cb: _cb
        });
    },

    /**
     * 获取用户非敏感信息
     * @param {Array of String} data.fields 查询域
     */
    getUserData: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getUserData'), {
            data: data,
            global: false,
            cb: _cb
        });
    },

    /**
     * 设置用户指引状态
     */
    setUserIsSeeGuidelines: function (type, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('setUserIsSeeGuidelines'), {
            data: {
                isSeeGuidelines: type
            },
            global: false,
            cb: _cb
        });
    },

    /**
     * 获取用户指引状态
     */
    getUserIsSeeGuidelines: function (cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getUserIsSeeGuidelines'), {
            cb: _cb
        });
    },

    /**
     * 设置用户指引状态 - 新版本
     */
    setUserGuideData: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('setUserGuideData'), {
            data: data,
            global: false,
            cb: _cb
        });
    },

    /**
     * 获取用户指引状态 - 新版本
     */
    getUserGuideData: function (cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getUserGuideData'), {
            cb: _cb
        });
    },


    /**
     * 获取公共数据
     */
    getComData: function (cb, fail) {
        if (appUtil.getComData()) {
            cb(appUtil.getComData());
        } else {
            $(document).on('login_data_inited', function handler() {
                $(document).off('login_data_inited', handler)
                cb(appUtil.getComData());
            })
        }

        this._getComDataStats();
    },

    /**
     * getComData使用统计
     */
    _getComDataStats: function () {
        if (navigator.userAgent.indexOf("Chrome") < 0) return;

        if (this._getComDataPathCnt === undefined) this._getComDataPathCnt = {};

        var path = router.getFragment();
        if (!this._getComDataPathCnt[path]) this._getComDataPathCnt[path] = 1;
        if (this._getComDataPathCnt[path] > 3) return;

        var stack = new Error().stack || '';

        stack = stack.replace(/(http|https):\/\/img.qcloud.com\/qcloud\/app\/qcconsole_web\/((dest|build))\//g, '');
        stack = stack.replace(/(.+.js)\?(.+\=.+&?)+/g, '$1)');
        if (/startup|displayAuthNavUser|HTMLDocument\.elemData\.handle|projectsSelector|render\s\(platform\.js\)/g.test(stack)) return;

        stack = stack.replace(/eval/g, '');
        this._getComDataPathCnt[path]++;
    },

    /**
     * 查询公共流程(返回status-- 0:成功 1:失败 2:未完成)
     */
    getFlowCscResult: function (data, cb, fail, from) {
        var _self = this,
            _cb = function (ret) {

                var retData = ret.data || {},
                    retOutPut = retData.output;

                dataManager.commonCb(ret, cb, fail);

                if (ret.code == 0) { //需要先解绑再执行操作的提示
                    if (retOutPut && retOutPut['failedInfo']) {
                        for (var i = 0, item; item = retOutPut['failedInfo'][i]; i++) {
                            var errorNum = item.errorNum;
                            errorNum = typeof (errorNum) == 'object' ? errorNum[0] : errorNum;
                            errorNum = errorNum.toString().substring(1);
                            var errTipTxt = constants['FLOW_RESULT_FAIL'][errorNum] || '操作执行失败，请稍后重试';
                            tips.error(errTipTxt);
                            break;
                        }
                    } else if (retOutPut && retOutPut.errorCode) {
                        var errTipTxt = constants['FLOW_RESULT_FAIL'][retOutPut.errorCode] || '操作执行失败，请稍后重试';
                        tips.error(errTipTxt);
                    }
                }

            };

        net.send(config.get('getFlowCscResult'), {
            data: data,
            global: from === 'vpc',
            cb: _cb
        });
    },

    /**
     * 获取cvm列表
     */
    getCvmList: function (data, cb, fail, ajaxGlobal) {
        var _self = this,
            _cgiCof = config.get('getCvmList'),
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        if (data.method == 'post') {
            _cgiCof.method = 'post';
        } else {
            _cgiCof.method = 'get';
        }
        net.send(_cgiCof, {
            data: data,
            global: ajaxGlobal,
            cb: _cb
        });
    },
    /**
     * getCvmMore 查询更多cvm信息
     */
    getCvmMore: function (data, cb, fail, global, cacheKey, tipErr) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail, cacheKey, tipErr);
            };

        net.send(config.get('getCvmMore'), {
            data: data,
            cb: _cb,
            global: global
        });
    },
    /**
     * CVM概览-获取公告
     */
    getCVMNotice: function (cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getCVMNotice'), {
            cb: _cb
        });
    },

    /**
     * 重启cvm
     */
    rebootCvm: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('rebootCvm'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 开机关机
     */
    cvmAction: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('cvmAction'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 批量改名
     */
    modifyCvmAliasBatch: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('modifyCvmAliasBatch'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 重装系统
     */
    resetCvmSystem: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('resetCvmSystem'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 重装系统之本地盘切换系统
     */
    switchCvmSystem: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('switchCvmSystem'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 根据地域与机型获取按量计费的pid列表（阶梯计费）
     */
    getQuotiesChargeItem: function (data, cb, fail, cacheKey, tipErr) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail, cacheKey, tipErr);
            };

        net.send(config.get('getQuotiesChargeItem'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 重置密码
     */
    resetCvmPasswd: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('resetCvmPasswd'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 格式化硬盘
     */
    formatCvmDisk: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('formatCvmDisk'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 获取历史带宽
     */
    getBandwidthHistory: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getBandwidthHistory'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 获取价格
     */
    getPrice: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getPrice'), {
            data: data,
            global: false,
            cb: _cb
        });
    },

    /**
     * 获取按小时价格
     */
    getPriceForHour: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getPriceForHour'), {
            data: data,
            global: false,
            cb: _cb
        });
    },

    /**
     * 获取带宽退费信息
     */
    getBandwidthReturnFittingPrice: function (data, cb, fail) {
        var _cb = function (ret) {
            dataManager.commonCb(ret, cb, fail);
        };

        net.send(config.get('getBandwidthReturnFittingPrice'), {
            data: data,
            global: false,
            cb: _cb
        });
    },

    /**
     * 升级按量计费主机配置
     */
    upgradeHourCvm: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('upgradeHourCvm'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 升级按量计费带宽
     */
    upgradeHourCvmBandwidth: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('upgradeHourCvmBandwidth'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 校验是否服务商帐号
     */
    getServiceAccount: function (cb, fail, dataManageKey) {
        dataManageKey || (dataManageKey = 'is_user_service_account');
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail, dataManageKey);
            };

        if (dataManager.get(dataManageKey)) {
            cb(dataManager.get(dataManageKey));
        } else {
            net.send(config.get('getServiceAccount'), {
                data: {},
                cb: _cb
            });
        }
    },

    /**
     * 获取用户真实账户，如果传入fakeQQ，返回登录邮箱或者手机号，如果传入qq，返回qq
     */
    getAccounts: function (data, cb, fail) {
        var _cb = function (ret) {
            dataManager.commonCb(ret, cb, fail);
        };

        net.send(config.get('getAccounts'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 制作镜像
     */
    createCvmImage: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('createCvmImage'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 退还机器
     */
    returnCvm: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('returnCvm'), {
            data: data,
            cb: _cb
        });
    },
    /**
     * 包年包月主机退费信息
     */
    canPrepaidReturn: function (data, cb, fail) {
        var _self = this;
        var _cb = function (ret) {
            dataManager.commonCb(ret, cb, fail);
        };
        net.send(config.get('canPrepaidReturn'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 单独校验验证码
     */
    verifyCode: function (data, cb, fail) {
        var _self = this;
        var _cb = function (ret) {
            dataManager.commonCb(ret, cb, fail);
        };

        net.send(config.get('verifyCode'), {
            data: data,
            cb: _cb
        });
    },
    /**
     * 销毁机器
     */
    destroyCvm: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('destroyCvm'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 独享型子机放入回收站
     */
    destroyCvmAndCdhCvm: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('destroyCvmAndCdhCvm'), {
            data: data,
            cb: _cb
        });
    },

    returnCvmInTime: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('returnCvmInTime'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 从回收站恢复独享型子机
     */
    restoreCdhCvm: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('restoreCdhCvm'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 查询服务市场镜像列表
     * @param cb
     * @param fail
     */
    getImageCategories: function (cb, fail) {
        net.send(config.get('getImageCategories'), {
            cb: function (ret) {
                dataManager.commonCb(ret, cb, fail);
            }
        });
    },
    /**
     * 查询服务市场镜像列表
     * @param cb
     * @param fail
     */
    getImageProductsDetail: function (data, cb, fail) {
        net.send(config.get('getImageProductsDetail'), {
            data: data,
            cb: function (ret) {
                dataManager.commonCb(ret, cb, fail);
            }
        });
    },
    /**
     * 查询服务市场镜像列表
     * @param cb
     * @param fail
     */
    getImagesDetail: function (data, cb, fail) {
        net.send(config.get('getImagesDetail'), {
            data: data,
            cb: function (ret) {
                dataManager.commonCb(ret, cb, fail);
            }
        });
    },

    /**
     * 服务市场白名单
     * @param cb
     * @param fail
     */
    getMarketWhiteList: function (cb, fail) {
        net.send(config.get('getMarketWhiteList'), {
            cb: function (ret) {
                dataManager.commonCb(ret, cb, fail);
            }
        });
    },

    /**
     * 是否可重装当前系统
     * @param data
     * @param cb
     * @param fail
     */
    checkResetSys: function (data, cb, fail) {
        var _cb = function (ret) {
            dataManager.commonCb(ret, cb, fail);
        };

        net.send(config.get('checkResetSys'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 设置带宽上限
     */
    setBandwidthLimit: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('setBandwidthLimit'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 设置网络按流量带宽峰值
     */
    'setBandwidthLimitForFlow': function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('setBandwidthLimitForFlow'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 分配至项目
     */
    changeProject: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('changeProject'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 设置自动更新标识
     */
    setRenewFlag: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('setRenewFlag'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 获取进入时查询的所有白名单数据
     */
    getAllWhiteList: function (cb) {
        var key = 'allWhiteList';
        if (dataManager.get(key)) {
            cb && cb(dataManager.get(key))
        } else {
            $(document).on('allWhiteListLoaded', function () {
                cb && cb(dataManager.get(key))
            })
        }
    },

    /**
     * 判断是否为云服务器预付费用户（后付费某些情况下功能不可用，需要引导他们切换预付费）
     * 用法： appUtil.isPrepaid().done( yesCb ).fail( noCb );
     * @returns {Promise}
     */
    isPrepaid: function () {
        var def = $.Deferred();
        this.getAllWhiteList(function (data) {
            if (data.PrepaidForCVM || data.CDB_PrepaidForCDB) {
                def.resolve();
            } else {
                def.reject();
            }
        });
        return def;
    },


    /**
     * 获取平台消息列表
     */
    getMsgList: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getMsgList'), {
            data: data,
            global: false,
            cb: _cb
        });
    },

    /**
     * 获取工单数量
     */
    getTicketNum: function (cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getTicketNum'), {
            global: false,
            cb: _cb
        });
    },

    /**
     * 获取代金券数量
     */
    getVouchersNum: function (cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getVouchersNum'), {
            global: false,
            cb: _cb
        });
    },

    /**
     * 查询密钥列表
     */
    queryKeypair: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('queryKeypair'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 创建密钥
     */
    createKeypair: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('createKeypair'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 加载密钥
     */
    loadKeypair: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('loadKeypair'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 修改密钥
     */
    modifyKeypair: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('modifyKeypair'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 删除密钥
     */
    deleteKeypair: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('deleteKeypair'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 关联密钥
     */
    manageCvmKey: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('manageCvmKey'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 密钥详情
     */
    detailKeypair: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, function (data) {
                    var detailData = data.detail_list ? data.detail_list[0] : [{}];
                    var bindList = detailData.bind_uuidlist || [];
                    detailData.regionList = []
                    bindList.map(function (item) {
                        detailData.regionList.push(item.area)
                        return item.uuid
                    })
                    cb(data)
                }, fail);
            };

        net.send(config.get('detailKeypair'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * @method loadChartData
     * @param {String} nameSpace 命名空间，如Cvm/Cbs
     * @param {Array} chartInfos 图标信息，格式：分类类型_图表类型_时长，如["cpu_Device.cpuUtil_7"]
     * @param {Function} onSuccess 请求成功回调
     * @param {Function} onFail 请求失败回调
     * @param {String} key 针对cvm设备请求需携带内网ip/cbs则是uuid
     * @param {String} [options] 可选参数
     * @description 加载指定图表数据 (已下线)
     * @author brianlin
     */
    /*loadChartData: function (nameSpace,chartInfos,onSuccess,onFail,key,options) {
        var that = this;
        that.chartDataCache || (that.chartDataCache = {});

        var needQueryChartInfos = [];
        var now = new Date().getTime();
        for(var i = 0;i < chartInfos.length; i++){
            var cache = that.chartDataCache[nameSpace+'_'+key+'_'+chartInfos[i]];
            if(cache){
                //cache存在但已过期，实时数据五分钟过期
                if((chartInfos[i].indexOf('1h') > 0  || chartInfos[i].indexOf('TODAY') > 0) && cache.time+300*1000 < now){
                    needQueryChartInfos.push(chartInfos[i]);
                }
            }else{
                needQueryChartInfos.push(chartInfos[i]);
            }
        }
        if(needQueryChartInfos.length){
            net.send(config.get('loadChartData'), {
                data:{
                    nameSpace: nameSpace,
                    chartInfos: needQueryChartInfos.join('|'),
                    uuid: key,
                    options: options
                },
                cb: function (result){
                    dataManager.commonCb(result,function(data){
                        for(var j=0;j < data.length; j++){
                            that.chartDataCache[nameSpace+'_'+key+'_'+data[j].chartInfo] = {'time':now,'chartData':data[j].chartData};
                        }
                        var cacheData = [];
                        for(i = 0;i < chartInfos.length; i++){
                            if(that.chartDataCache[nameSpace+'_'+key+'_'+chartInfos[i]]){
                                cacheData.push({'chartInfo':chartInfos[i],'chartData':util.cloneObject(that.chartDataCache[nameSpace+'_'+key+'_'+chartInfos[i]].chartData)});
                            }
                        }
                        onSuccess(cacheData);
                    },onFail);
                }
            });
        }else{
            var cacheData = [];
            for(i = 0;i < chartInfos.length; i++){
                cacheData.push({'chartInfo':chartInfos[i],'chartData':util.cloneObject(that.chartDataCache[nameSpace+'_'+key+'_'+chartInfos[i]].chartData)});
            }
            onSuccess(cacheData);
        }
    },*/

    /**
    * @method loadChartDataV2
    * @desc  第二版的获取数据接口，这里是做了api统一化
    * @param {String} param 参数列表
    * @param {Function} onSuccess 请求成功回调
    * @param {Function} onFail 请求失败回调
    * @param {String} key 针对cvm设备请求需携带内网ip/cbs则是uuid
    * @param {String} [options] 可选参数
    * @description 加载指定图表数据
    * @author liamhuang
    * @date   20160416
    */
    loadChartDataV2: function (param, onSuccess, onFail, key, options) {
        var that = this;
        param = param || {};
        var chartInfos = param.chartInfos || [];
        var namespace = param.namespace || "cvm";
        var date = param.date || "";
        var area = param.area || 1;

        var appId = param.appId;
        var vpcId = param.vpcId;
        var ip = param.ip;
        var uuid = param.uuid;

        that.chartDataCache || (that.chartDataCache = {});

        var needQueryChartInfos = [];
        var outTrafficInfos = [];    //因为出流量的查询方式和之前的不一样。所以这里需要单独列出来
        var hasCache = false;

        var now = new Date().getTime();
        for (var i = 0; i < chartInfos.length; i++) {
            var cache = that.chartDataCache[key + '_' + chartInfos[i] + '_' + JSON.stringify(date)];
            if (cache) {
                //cache存在但已过期，实时数据五分钟过期
                if (date == "1h" && cache.time + 300 * 1000 < now) {
                    needQueryChartInfos.push(chartInfos[i]);
                    continue;
                }
                hasCache = true;
            } else {
                needQueryChartInfos.push(chartInfos[i]);
            }
        }

        if (needQueryChartInfos.length) {
            var list = [];
            for (var i = 0; i < needQueryChartInfos.length; i++) {
                list.push({       //参数列表
                    resourceType: namespace,
                    resourceId: key,
                    resourceArea: area,
                    metric: needQueryChartInfos[i],
                    time: date,
                    vpc: vpcId,
                    appId: appId,
                    ip: ip,
                    uuid: uuid
                });
            }

            var url = 'https://monitor.' + QCCONSOLE_HOST.substr(8) + '/index.php/' + namespace + '/graph?g_tk=' + util.getACSRFToken() + '&cb=?';
            var params = {
                _format: "jsonp",
                querys: list
            };

            net.getJSON(url, params, function (result) {
                dataManager.commonCb(result, function (data) {
                    data = data || {};
                    var graphs = data.graphs || [];
                    for (var j = 0; j < graphs.length; j++) {
                        if (graphs[j]) {
                            that.chartDataCache[key + '_' + graphs[j].metric + '_' + JSON.stringify(date)] = { 'time': now, 'chartData': graphs[j] };
                        }
                    }

                    var cacheData = [];
                    for (i = 0; i < chartInfos.length; i++) {
                        if (that.chartDataCache[key + '_' + chartInfos[i] + '_' + JSON.stringify(date)]) {
                            cacheData.push({ 'chartInfo': chartInfos[i], 'chartData': util.cloneObject(that.chartDataCache[key + '_' + chartInfos[i] + '_' + JSON.stringify(date)].chartData) });
                        }
                    }
                    onSuccess(cacheData);
                }, onFail);
            }
            );

        } else {    //缓存部分
            var cacheData = [];
            for (i = 0; i < chartInfos.length; i++) {
                cacheData.push({ 'chartInfo': chartInfos[i], 'chartData': util.cloneObject(that.chartDataCache[key + '_' + chartInfos[i] + '_' + JSON.stringify(date)].chartData) });
            }
            onSuccess(cacheData);
        }
    },

    //获取监控Agent数据
    loading: false,
    cbList: [],
    getMonitorAgent: function (data, cb, fail) {
        var _self = this;
        var cache = _self.agentCache || {};
        var now = Date.now();
        if (cache && cache.time && cache.time + 300 * 1000 >= now) {		//cache存在但已过期，数据五分钟过期
            cb(cache.data);     //如果有缓存，就直接返回了
        } else {
            _self.cbList && _self.cbList.push({
                "cb": cb,
                "fail": fail
            });

            if (_self.loading) {    //还在请求中，就先把回调方法保存起来 	
                return;
            }
            _self.loading = true;
            net.send(config.get('getMonitorAgent'), {
                data: data,
                cb: function (ret) {      //如果已经有数据了，就保存到cache中
                    _self.agentCache = ret;               //记录下上次返回的数据
                    _self.agentCache.time = Date.now();   //记录下时间

                    for (var i = 0; i < _self.cbList.length; i++) {
                        var cur = _self.cbList[i];
                        if (cur) {
                            dataManager.commonCb(ret, cur.cb || function () { }, cur.fail || function () { });
                        }
                    }
                    _self.cbList = [];    //返回数据置空
                    _self.loading = false;
                }
            });
        }
    },

    /**
     * @method queryKeyByIps
     * @param {Array} devices device_list
     * @param {Function} onSuccess 请求成功回调
     * @param {Function} onFail 请求失败回调
     * @description 查询指定ip的key私钥
     * @author brianlin
     */
    queryKeyByIps: function (devices, onSuccess, onFail) {
        net.send(config.get('queryKeyByIps'), {
            data: devices,
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * @method queryCvmOpLogs
     * @param {Array} deviceIds deviceId数组
     * @param {String} startTime 开始时间
     * @param {String} endTime 结束时间
     * @param {Integer} offset 查询偏移量
     * @param {Integer} count 查询量
     * @param {Function} onSuccess 请求成功回调
     * @param {Function} onFail 请求失败回调
     * @description 查询指定deviceId的操作日志
     * @author brianlin
     */
    queryCvmOpLogs: function (deviceIds, startTime, endTime, offset, count, onSuccess, onFail) {
        net.send(config.get('queryCvmOpLogs'), {
            data: {
                deviceIds: deviceIds.join('|'),
                startTime: startTime,
                endTime: endTime,
                offset: offset,
                count: count
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * @method queryImages
     * @param {Integer} regionId 地区id
     * @param {Array} imageStatus 镜像状态数组
     * @param {Function} onSuccess 请求成功回调
     * @param {Function} onFail 请求失败回调
     * @param {Int} virtualPlatform 虚拟平台 0:kvm，1:xen
     * @description 请求指定地区和状态的镜像列表
     * @author brianlin
     */
    queryImages: function (regionId, imageStatus, onSuccess, onFail, virtualPlatform, global) {
        var data = {
            regionId: regionId,
            imgStatus: imageStatus
        };
        if (virtualPlatform != undefined) {
            data.virtualPlatform = virtualPlatform;
        }
        net.send(config.get('queryImages'), {
            data: data,
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            },
            global: global
        });
    },

    queryImageDetail: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('queryImages'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * @method delImages
     * @param {Array} imageIds 镜像Id数组
     * @param {Function} onSuccess 请求成功回调
     * @param {Function} onFail 请求失败回调
     * @description 删除指定id镜像
     * @author brianlin
     */
    delImages: function (imageIds, onSuccess, onFail) {
        net.send(config.get('delImages'), {
            data: {
                imageIds: imageIds
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * @method modImage
     * @param {String} imageId 镜像id
     * @param {String} imageName 镜像名称
     * @param {String} imageDesc 镜像描述
     * @param {Function} onSuccess 请求成功回调
     * @param {Function} onFail 请求失败回调
     * @description 修改镜像名称镜像描述
     * @author brianlin
     */
    modImage: function (imageId, imageName, imageDesc, onSuccess, onFail) {
        net.send(config.get('modImage'), {
            data: {
                imageId: imageId,
                imageName: imageName,
                imageDesc: imageDesc
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * @method query cbs list
     * @param data
     * @param onSucc
     * @param onFail
     */
    queryCbsList: function (data, onSucc, onFail, ajaxGlobal) {
        net.send(config.get('queryCbsList'), {
            data: data,
            global: ajaxGlobal,
            cb: function (result) {
                dataManager.commonCb(result, onSucc, onFail);
            }
        });
    },

    /**
     * @method rename cbs alias
     * @param data
     * @param onSucc
     * @param onFail
     */
    modifyCbsAlias: function (data, onSucc, onFail) {
        net.send(config.get('modifyCbsAlias'), {
            data: data,
            cb: function (result) {
                dataManager.commonCb(result, onSucc, onFail);
            }
        });
    },

    /**
     * @method set cbs autorenewflag
     * @param data
     * @param onSucc
     * @param onFail
     */
    setCbsAutoRenewFlag: function (data, onSucc, onFail) {
        net.send(config.get('setCbsAutoRenewFlag'), {
            data: data,
            cb: function (result) {
                dataManager.commonCb(result, onSucc, onFail);
            }
        });
    },

    /**
     * 总览-获取总览基础信息
     */
    getDashboardBase: function (cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getDashboardBase'), {
            cb: _cb
        });
    },

    /**
     * 总览-获取云监控数据
     */
    getAppMonitor: function (cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        $.ajax({
            url: '//monitor.' + QCCONSOLE_HOST.substr(8) + '/index.php/alarm/scope',
            dataType: 'jsonp',
            data: {
                _format: 'json',
                g_tk: util.getACSRFToken()
            },
            jsonp: 'cb',
            success: _cb,
            error: fail
        });
    },

    /**
     * 总览-获取云安全数据
     */
    getAppSecurity: function (cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getAppSecurity'), {
            cb: _cb
        });
    },

    /**
     * 总览-获取公网流量
     */
    getNetworkFlow: function (cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getNetworkFlow'), {
            cb: _cb
        });
    },

    /**
     * 总览-获取开发商余额
     */
    getMargin: function (cb, fail) {
        var _self = this,
            cacheData,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail, 'cache_margin');
            };
        cacheData = dataManager.get('cache_margin');
        if (cacheData) {
            cb(cacheData);
            return;
        }
        net.send(config.get('getMargin'), {
            cb: _cb
        });
    },

    /**
     * 总览-获取服务统计数量
     */
    getServicesInfo: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getServicesInfo'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * 总览-获取即将过期服务数量
     */
    getExpireNum: function (data, cb, fail, global) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getExpireNum'), {
            data: data,
            global: global,
            cb: _cb
        });
    },

    /**
     * 总览-获取公告
     */
    getNotice: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getNotice'), {
            data: data,
            cb: _cb
        });
    },

    /**
     * @method getVpcRegionWhiteList
     * @description 获取vpc访问白名单列表
     * @author brianlin
     */
    getVpcRegionWhiteList: function (onSuccess, onFail) {
        net.send(config.get('getVpcRegionWhiteList'), {
            data: {
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * @method getVpcList
     * @param {Integer} regionId 地区id
     * @description 请求指定地区vpc列表
     * @author brianlin
     */
    getVpcList: function (regionId, onSuccess, onFail) {
        net.send(config.get('getVpcList'), {
            data: {
                regionId: regionId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    getVpcStatisticList: function (regionId, keyword, offset, limit, onSuccess, onFail) {
        net.send(config.get('getVpcStatisticList'), {
            data: {
                regionId: regionId,
                offset: offset,
                limit: limit,
                keyword: keyword
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    getVpcExternalStatistic: function (regionId, vpcIds, keys, onSuccess, onFail) {
        net.send(config.get('getVpcExternalStatistic'), {
            data: {
                regionId: regionId,
                vpcIds: vpcIds,
                keys: keys
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    getVpcTopo: function (regionId, vpcId, onSuccess, onFail) {
        net.send(config.get('getVpcTopo'), {
            data: {
                regionId: regionId,
                vpcId: vpcId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    getVpcTopoExternal: function (regionId, vpcId, onSuccess, onFail) {
        net.send(config.get('getVpcTopoExternal'), {
            data: {
                regionId: regionId,
                vpcId: vpcId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    updateCvm: function (regionId, vpcId, uuid, srcVpcIp, dstVpcIp, srcSubnetId, dstSubnetId, onSuccess, onFail) {
        net.send(config.get('updateCvm'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                uuid: uuid,
                srcVpcIp: srcVpcIp,
                dstVpcIp: dstVpcIp,
                srcSubnetId: srcSubnetId,
                dstSubnetId: dstSubnetId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    getVpcSubnetStatisticList: function (data, onSuccess, onFail) {
        net.send(config.get('getVpcSubnetStatisticList'), {
            data: data,
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    getVpcSubnetIpCounts: function (regionId, subnetList, onSuccess, onFail) {
        net.send(config.get('getVpcSubnetIpCounts'), {
            data: {
                regionId: regionId,
                subnetList: subnetList
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    // 路由表
    getVpcRtbStatisticList: function (regionId, vpcId, keyword, offset, limit, onSuccess, onFail) {
        net.send(config.get('getVpcRtbStatisticList'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                offset: offset,
                limit: limit,
                keyword: keyword
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    // VPN网关
    getVpcVpnGwStatisticList: function (regionId, vpcId, keyword, offset, limit, onSuccess, onFail) {
        net.send(config.get('getVpcVpnGwStatisticList'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                offset: offset,
                limit: limit,
                keyword: keyword
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    getVpcVpnGwStatisticListEx: function (regionId, unVpcId, vpnGwId, keyword, offset, limit, onSuccess, onFail) {
        // 为了app.js先发，做个兼容
        if (/*arguments.length<=7*/ $.isFunction(limit)) {
            onFail = onSuccess;
            onSuccess = limit;
            limit = offset;
            offset = keyword;
            keyword = vpnGwId;
            vpnGwId = undefined;
        }
        net.send(config.get('getVpcVpnGwStatisticListEx'), {
            data: {
                regionId: regionId,
                vpcId: unVpcId,
                vpnGwId: vpnGwId,
                offset: offset,
                limit: limit,
                keyword: keyword
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    getSslVpnStatisticListEx: function (regionId, unVpcId, sslVpnId, keyword, offset, limit, onSuccess, onFail) {
        net.send(config.get('getSslVpnStatisticListEx'), {
            data: {
                regionId: regionId,
                vpcId: unVpcId,
                sslVpnId: sslVpnId,
                offset: offset,
                limit: limit,
                keyword: keyword
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    getVpcVpnUsedList: function (regionId, onSuccess, onFail) {
        net.send(config.get('getVpcVpnUsedList'), {
            data: {
                regionId: regionId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    // VPN通道
    getVpcVpnConnStatisticList: function (regionId, vpcId, keyword, offset, limit, onSuccess, onFail) {
        net.send(config.get('getVpcVpnConnStatisticList'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                offset: offset,
                limit: limit,
                keyword: keyword
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    // 对端网关
    getVpcUserGwStatisticList: function (regionId, keyword, offset, limit, onSuccess, onFail) {
        net.send(config.get('getVpcUserGwStatisticList'), {
            data: {
                regionId: regionId,
                offset: offset,
                limit: limit,
                keyword: keyword
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },


    /**
     * @method addVpc
     * @param {Integer} regionId 地区id
     * @param {Integer} vpcId vpcId
     * @description 请求vpc内容
     * @author brianlin
     */
    getVpcView: function (regionId, vpcId, onSuccess, onFail) {
        net.send(config.get('getVpcView'), {
            data: {
                regionId: regionId,
                vpcId: vpcId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * @method addVpc
     * @param {Integer} regionId 地区id
     * @param {String} vpcName vpc名称
     * @param {String} vpcCIDR vpcCIDR
     * @param {Object} subnetList 子网列表
     * @description 创建vpc网络
     * @author brianlin
     */
    addVpc: function (regionId, vpcName, vpcCIDR, subnetList, onSuccess, onFail) {
        net.send(config.get('addVpc'), {
            data: {
                regionId: regionId,
                vpcName: vpcName,
                vpcCIDR: vpcCIDR,
                subnetList: subnetList
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * @method delVpc
     * @param {Integer} regionId 地区id
     * @param {String} vpcId vpcId
     * @description 删除vpc网络
     * @author brianlin
     */
    delVpc: function (regionId, vpcId, onSuccess, onFail) {
        net.send(config.get('delVpc'), {
            data: {
                vpcId: vpcId,
                regionId: regionId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * @method modifyVpcProperty
     * @param {Integer} regionId 地区id
     * @param {String} vpcId vpcId
     * @param {String} vpcName vpc名称
     * @description 删除vpc网络
     * @author brianlin
     */
    modifyVpcProperty: function (regionId, vpcId, vpcName, onSuccess, onFail) {
        net.send(config.get('modifyVpcProperty'), {
            data: {
                vpcId: vpcId,
                vpcName: vpcName,
                regionId: regionId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * @method modifyVPCSubnetRouteTable
     * @param {Integer} regionId 地区id
     * @param {String} vpcId vpcId
     * @param {String} subnetId 子网id
     * @param {String} routeId 路由表id
     * @description 修改子网关联路由表
     * @author brianlin
     */
    modifyVPCSubnetRouteTable: function (regionId, vpcId, subnetId, routeId, onSuccess, onFail) {
        net.send(config.get('modifyVPCSubnetRouteTable'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                subnetId: subnetId,
                routeId: routeId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * @method getVpcDeviceCount
     * @param {Integer} regionId 地区id
     * @param {Integer} vpcId vpcId
     * @description 请求vpc设备数量
     * @author brianlin
     */
    getVpcDeviceCount: function (regionId, vpcId, onSuccess, onFail) {
        net.send(config.get('getVpcDeviceCount'), {
            data: {
                regionId: regionId,
                vpcId: vpcId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * @method getSubnetInfo
     * @param regionId
     * @param vpcId
     * @param subnetId
     * @param onSuccess
     * @param onFail
     * @description 请求指定vpc下指定subnet信息
     */
    getSubnetInfo: function (regionId, vpcId, subnetId, onSuccess, onFail) {
        net.send(config.get('getSubnetInfo'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                subnetId: subnetId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * @method addSubnet
     * @param regionId
     * @param vpcId
     * @param subnetList
     * @param onSuccess
     * @param onFail
     */
    addSubnet: function (regionId, vpcId, subnetList, onSuccess, onFail) {
        net.send(config.get('addSubnet'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                subnetList: subnetList
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * @method queryZone
     * @param regionId
     * @param onSuccess
     * @param onFail
     */
    queryZone: function (regionId, onSuccess, onFail, tipErr) {
        net.send(config.get('queryZone'), {
            data: {
                regionId: regionId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail, false, tipErr);
            }
        });
    },

    /**
     * @method getVpcZoneWhiteList
     * @param zoneIds数组
     * @param onSuccess
     * @param onFail
     */
    getVpcZoneWhiteList: function (zoneIds, onSuccess, onFail) {
        net.send(config.get('getVpcZoneWhiteList'), {
            data: {
                zoneIds: zoneIds
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * @mthod modifySubnet
     * @param regionId
     * @param vpcId
     * @param subnetId
     * @param subnetName
     * @param rtbId
     * @param onSuccess
     * @param onFail
     */
    modifySubnet: function (regionId, vpcId, subnetId, subnetName, rtbId, onSuccess, onFail) {
        net.send(config.get('modifySubnet'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                subnetId: subnetId,
                subnetName: subnetName,
                rtbId: rtbId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    deleteSubnet: function (regionId, vpcId, subnetId, onSuccess, onFail) {
        net.send(config.get('deleteSubnet'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                subnetId: subnetId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    getVPCGatewayList: function (regionId, vpcId, gatewayType, onSuccess, onFail) {
        net.send(config.get('getVPCGatewayList'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                gatewayType: gatewayType
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    getVPCRouteTable: function (regionId, vpcId, routerId, rtbId, onSuccess, onFail) {
        net.send(config.get('getVPCRouteTable'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                routerId: routerId,
                rtbId: rtbId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    addVPCRouteTable: function (regionId, vpcId, routerId, rtbName, routeList, onSuccess, onFail) {
        net.send(config.get('addVPCRouteTable'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                routerId: routerId,
                rtbName: rtbName,
                routeList: routeList
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    modifyVPCRouteTable: function (regionId, vpcId, routerId, rtbId, rtbName, routeList, onSuccess, onFail) {
        net.send(config.get('modifyVPCRouteTable'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                routerId: routerId,
                rtbId: rtbId,
                rtbName: rtbName,
                routeList: routeList
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    deleteVPCRouteTable: function (regionId, vpcId, routerId, rtbId, onSuccess, onFail) {
        net.send(config.get('deleteVPCRouteTable'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                routerId: routerId,
                rtbId: rtbId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
    * @method getVpnGw
    * @param regionId
    * @param [vpcId]
    * @param [vpnGwId]
    * @param onSuccess
    * @param onFail
    */
    getVpnGw: function (regionId, vpcId, vpnGwId, onSuccess, onFail) {
        net.send(config.get('getVpnGw'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                vpnGwId: vpnGwId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * @method initVpnGw
     * @param data
     * @param onSuccess
     * @param onFail
     */
    initVpnGw: function (data, onSuccess, onFail) {
        net.send(config.get('initVpnGw'), {
            data: data,
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    clearVpnGw: function (regionId, vpcId, vpnGwId, onSuccess, onFail) {
        net.send(config.get('clearVpnGw'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                vpnGwId: vpnGwId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    clearSslVpn: function (regionId, vpcId, vpnGwId, onSuccess, onFail) {
        net.send(config.get('clearSslVpn'), {
            data: {
                regionId: regionId,
                vpcId: vpcId,
                sslVpnId: vpnGwId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
    * @method getVpnGwQuota
    * @param onSuccess
    * @param onFail
    */
    getVpnGwQuota: function (onSuccess, onFail) {
        net.send(config.get('getVpnGwQuota'), {
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * @method addVpnGw
     * @param data
     * @param onSuccess
     * @param onFail
     */
    addVpnGw: function (data, onSuccess, onFail) {
        net.send(config.get('addVpnGw'), {
            data: data,
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },
    modifyVpnGw: function (data, onSuccess, onFail) {
        net.send(config.get('modifyVpnGw'), {
            data: data,
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },
    addUserGw: function (data, onSuccess, onFail) {
        net.send(config.get('addUserGw'), {
            data: data,
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        })
    },
    modifyUserGw: function (data, onSuccess, onFail) {
        net.send(config.get('modifyUserGw'), {
            data: data,
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        })
    },
    delUserGw: function (data, onSuccess, onFail) {
        net.send(config.get('delUserGw'), {
            data: data,
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        })
    },
    addVpnConn: function (data, onSuccess, onFail) {
        net.send(config.get('addVpnConn'), {
            data: data,
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },
    modifyVpnConn: function (data, onSuccess, onFail) {
        net.send(config.get('modifyVpnConn'), {
            data: data,
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        })
    },
    delVpnConn: function (data, onSuccess, onFail) {
        net.send(config.get('delVpnConn'), {
            data: data,
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        })
    },
    /**
     * @method getVpnStuff
     * @param regionId
     * @param vpcId
     * @param onSuccess
     * @param onFail
     */
    getVpnStuff: function (regionId, vpcId, onSuccess, onFail) {
        net.send(config.get('getVpnStuff'), {
            data: {
                regionId: regionId,
                vpcId: vpcId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    /**
     * 查询通道列表
     * @param vpcId
     * @param vpcConnId
     * @param taskId
     * @param onSuccess
     * @param onFail
     */
    getVpnConnProperty: function (vpcId, vpcConnId, taskId, onSuccess, onFail) {
        net.send(config.get('getVpnConnProperty'), {
            data: {
                vpcId: vpcId,
                vpcConnId: vpcConnId,
                taskId: taskId
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    getVpnPrice: function (data, cb, fail) {
        var _cb = function (ret) {
            dataManager.commonCb(ret, cb, fail);
        };

        net.send(config.get('getVpnPrice'), {
            data: data,
            global: false,
            cb: _cb
        });
    },

    payByCart: function (data, cb, fail) {
        var _cb = function (ret) {
            dataManager.commonCb(ret, cb, fail);
        };

        net.send(config.get('payByCart'), {
            data: data,
            global: false,
            cb: _cb
        });
    },

    payByCartCvm: function (data, cb, fail) {
        var _cb = function (ret) {
            dataManager.commonCb(ret, cb, fail);
        };

        net.send(config.get('payByCartCvm'), {
            data: data,
            global: false,
            cb: _cb
        });
    },

    getDealsByCond: function (data, cb, fail) {
        var _cb = function (ret) {
            dataManager.commonCb(ret, cb, fail);
        };

        net.send(config.get('getDealsByCond'), {
            data: data,
            global: false,
            cb: _cb
        });
    },
    getUserGwVendor: function (cb, fail) {
        var _cb = function (ret) {
            dataManager.commonCb(ret, cb, fail);
        };

        net.send(config.get('getUserGwVendor'), {
            global: false,
            cb: _cb
        });
    },
    /**
     * 获取VPN网关/通道监控数据
     * @param data
     * @param cb
     * @param fail
     */
    loadVpnChartData: function (data, cb, fail) {
        net.send(config.get('loadVpnChartData'), {
            data: data,
            cb: function (ret) {
                dataManager.commonCb(ret, cb, fail, false, false);
            }
        });
    },

    /**
     * 获取vpc下公网网关的网络使用情况
     * @param regionId
     * @param vpcId
     * @param cb
     * @param fail
     */
    getGwStatusList: function (regionId, vpcId, cb, fail) {
        net.send(config.get('getGwStatusList'), {
            data: {
                regionId: regionId,
                vpcId: vpcId
            },
            cb: function (ret) {
                dataManager.commonCb(ret, cb, fail, false, false);
            }
        });
    },

    /**
     * 获取vpc下vpn网关的网络使用情况
     * @param regionId
     * @param vpcId
     * @param cb
     * @param fail
     */
    getVpnGwStatusList: function (regionId, vpcId, cb, fail) {
        net.send(config.get('getVpnGwStatusList'), {
            data: {
                regionId: regionId,
                vpcId: vpcId
            },
            cb: function (ret) {
                dataManager.commonCb(ret, cb, fail, false, false);
            }
        });
    },

    /**
     * 获取vpc下vpn通道的网络使用情况
     * @param regionId
     * @param vpcId
     * @param cb
     * @param fail
     */
    getVpnConnStatusList: function (regionId, vpcId, cb, fail) {
        net.send(config.get('getVpnConnStatusList'), {
            data: {
                regionId: regionId,
                vpcId: vpcId
            },
            cb: function (ret) {
                dataManager.commonCb(ret, cb, fail, false, false);
            }
        });
    },

    /**
     * 获取操作日志
     * @param data
     * @param cb
     * @param fail
     */
    getOperatelogList: function (data, cb, fail, ajaxGlobal) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getOperatelogList'), {
            data: data,
            global: ajaxGlobal,
            cb: _cb
        });
    },

    queryConfigureProducts: function (data, cb, fail, ajaxGlobal) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('queryConfigureProducts'), {
            data: data,
            global: ajaxGlobal,
            cb: _cb
        });
    },

    updateUserDefined: function (data, cb, fail, ajaxGlobal) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('updateUserDefined'), {
            data: data,
            global: ajaxGlobal,
            cb: _cb
        });
    },

    queryConfigureCodeData: function (data, cb, fail, ajaxGlobal) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('queryConfigureCodeData'), {
            data: data,
            global: ajaxGlobal,
            cb: _cb
        });
    },

    /*
     * 查询开发商列表
     */
    getDeveloperAccountList: function (data, cb, fail, ajaxGlobal) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getDeveloperAccountList'), {
            data: data,
            global: ajaxGlobal,
            cb: _cb
        });
    },

    /*
     * 切换开发商
     */
    switchDeveloperAccount: function (data, cb, fail, ajaxGlobal) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('switchDeveloperAccount'), {
            data: data,
            global: ajaxGlobal,
            cb: _cb
        });
    },

    /*
     * 黑石重置密码
     */
    resetCpmPasswd: function (data, cb, fail, ajaxGlobal) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('resetCpmPasswd'), {
            data: data,
            global: ajaxGlobal,
            cb: _cb
        });
    },

    //黑石询价
    getPriceBm: function (data, cb, fail) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getPriceBm'), {
            data: data,
            global: false,
            cb: _cb
        });
    },

    /**
     * 黑石VPC 拉取VPN 网关列表
     */
    getVpcBmVpnGwList: function (regionId, unVpcId, keyword, offset, limit, onSuccess, onFail) {
        net.send(config.get('getVpcBmVpnGwList'), {
            data: {
                regionId: regionId,
                vpcId: unVpcId,
                offset: offset,
                limit: limit,
                keyword: keyword
            },
            cb: function (result) {
                dataManager.commonCb(result, onSuccess, onFail);
            }
        });
    },

    //新版下单
    generateDeals: function (data, cb, fail) {
        var _cb = function (ret) {
            dataManager.commonCb(ret, cb, fail);
        };

        net.send(config.get('generateDeals'), {
            data: data,
            global: false,
            cb: _cb
        });
    },

    /**
     * 云API通用透传接口
     * @param regionId
     * @param serviceType
     * @param cmd
     * @param data
     * @param cb
     * @param fail
     * @param {Function} [humanizeCgwErrorCode]
     *  云API这里，cgw的错误码可以交由浏览器端处理，默认直接透传显示cgw错误信息
     */
    delegateCApi: function (regionId, serviceType, cmd, data, cb, fail, humanizeCgwErrorCode) {
        // 为undefined的字段不要传给后台！ 云API就是这么矫情，传空不会无视掉
        var filtered = {};
        Object.keys(data).forEach(function (key) {
            var value = data[key];
            if (value !== undefined) {
                filtered[key] = value;
            }
        });

        net.send({
            url: '/cgi/capi?' + $.param({ cmd: cmd, action: 'delegate', serviceType: serviceType }),
            method: 'post'
        }, {
            data: {
                regionId: regionId,
                serviceType: serviceType,
                cmd: cmd,
                data: filtered
            },
            cb: function (ret) {
                var cgwData = ret.data;
                dataManager.commonCb(ret, cb, fail, null, !cgwData /*|| !humanizeCgwErrorCode*/);
                if (ret.code !== 0 && cgwData) {
                    if (humanizeCgwErrorCode) {
                        tips.error(humanizeCgwErrorCode(cgwData.cgwerrorCode, cgwData));
                    } else {
                        tips.error(ret.msg || cgwData.message || cgwData.msg || '请求服务器失败');
                    }
                }
            }
        });
    },

    /**
     * 通过newMc后台请求barad，需在baradcontroller中配置白名单以及鉴权逻辑
     * @author cluezhang
     */
    queryBarad: function (regionId, options, cb, fail) {
        net.send({
            url: '/cgi/barad?action=query',
            method: 'post'
        }, {
            data: $.extend({
                regionId: regionId
            }, options),
            cb: function (ret) {
                dataManager.commonCb(ret, cb, fail);
            }
        });
    },

    /**
     * 流程查询
     * @param {Object} options
     * @param {String} options.taskId
     * @param {String} [options.regionId] regionId 缺省为当前全局地域
     * @param {Number} [options.checkTime=1000] 轮训间隔(ms)
     * @param {Boolean} [options.hideTips=false] 轮训过程中是否不显示顶部不 loading
     * @return {Promise}
     */
    checkTask: function (options) {
        var opts = $.extend({
            checkTime: 1000,
            hideTips: false,
            tips: ''
        }, options)

        opts.hideTips || tips.requestStart({ text: opts.tips })

        return new Promise(function (resolve, reject) {
            (function check() {
                manager.getFlowCscResult({ taskId: opts.taskId, regionId: opts.regionId }, function (data) {
                    if (data.status === 0) {
                        opts.hideTips || tips.requestStop()
                        resolve(data.output);
                    } else if (data.status === 1) {
                        opts.hideTips || tips.requestStop()
                        reject(data.output);
                    } else {
                        setTimeout(check, opts.checkTime);
                    }
                }, reject);
            })()
        })
    },

    getCdhChartData: function (data, cb, fail) {
        net.send(config.get('getCdhChartData'), {
            data: data,
            cb: function (ret) {
                dataManager.commonCb(ret, cb, fail, false, false);
            }
        });
    },

    getCdhMonitorChartData: function (data, cb, fail) {
        net.send(config.get('getCdhMonitorChartData'), {
            data: data,
            cb: function (ret) {
                dataManager.commonCb(ret, cb, fail, false, false);
            }
        });
    },
    getStatisticsGridData: function (data, cb, fail) {
        net.send(config.get('getStatisticsGridData'), {
            data: data,
            cb: function (ret) {
                dataManager.commonCb(ret, cb, fail, false, false);
            }
        });
    },
    getCdhChartDataBatch: function (data, cb, fail) {
        net.send(config.get('getCdhChartDataBatch'), {
            data: data,
            cb: function (ret) {
                dataManager.commonCb(ret, cb, fail, false, false);
            }
        });
    },
    getRealTimeCdhData: function (data, cb, fail) {
        net.send(config.get('getRealTimeCdhData'), {
            data: data,
            cb: function (ret) {
                dataManager.commonCb(ret, cb, fail, false, false);
            }
        });
    },
    /**
     * 拉取用户组
     */
    getGroupList: function (data, cb, fail, ajaxGlobal) {
        var _self = this,
            _cb = function (ret) {
                dataManager.commonCb(ret, cb, fail);
            };

        net.send(config.get('getGroupList'), {
            data: data,
            global: ajaxGlobal,
            cb: _cb
        });
    },
    /**
     * 心跳
     */
    ping: function (cb, fail) {
        net.send(config.get('ping'), {
            global: false,
            cb: function (ret) {
                dataManager.commonCb(ret, cb, fail);
            }
        })
    },
    /**
     * 获取可用区名称
     * @param {Object} data data.regionId, data.zoneId
     * @returns {Promise}
     */
    queryZoneName: function () {
        var zoneList = {}
        return function (data, opts) {
            var regionId = data.regionId
            var zoneId = data.zoneId

            opts = opts || {}
            var tipErr = opts.tipErr

            return (new Promise(function (resolve, reject) {
                if (!regionId) {
                    reject(new Error('缺少 regionId'))
                } if (!zoneId) {
                    reject(new Error('缺少 zoneId'))
                } else {
                    if (zoneList[regionId]) {
                        setTimeout(function () {
                            resolve(appUtil.clone(zoneList[regionId]))
                        }, 0)
                    } else {
                        manager.queryZone(regionId, function (data) {
                            zoneList[regionId] = data
                            resolve(appUtil.clone(zoneList[regionId]))
                        }, reject, tipErr)
                    }
                }
            })).then(function (zoneList) {
                var zoneName = ''

                zoneList.some(function (zone) {
                    if (zone.zoneId == zoneId) {
                        zoneName = zone.zoneName
                        return true
                    }
                })

                return zoneName || zoneId
            })
        }
    }(),

    /**
     * 查询续费时间（cvm、cbs续费）
     */
    getNextDate: function (deadline, monthSpan) {
        if (!deadline) {
            return ''
        }
        var date = appUtil.getDate(deadline);
        var day = date.getDate();

        var last = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        date.setMonth(date.getMonth() + (monthSpan || 1));

        if (date.getDate() < day) {
            date.setDate(0);
        } else if (day === last.getDate()) {
            date.setFullYear(date.getFullYear(), date.getMonth() + 1, 0);
        }
        return appUtil.formatDate(date, 'yyyy-MM-dd');
    },

    /**
     * 查询云主机可绑定的弹性网卡配额
     */
    getInstanceEniLimit: function (data, cb, fail) {
        this.delegateCApi(data.regionId, 'vpc', 'GetInstanceEniLimit', data, function (data) {
            cb(data)
        }, fail)
    },

    /**
     * 查询云主机已绑定的弹性网卡
     */
    getInstanceEniNum: function (data, cb, fail) {
        this.delegateCApi(data.regionId, 'vpc', 'DescribeNetworkInterfaces', data, function (data) {
            cb(data)
        }, fail)
    }

};


var caches = {};

/**
 * 简单的可缓存 manager 请求代理.只能给那些第一或者第二个参数为成功回调的请求方法使用
 * @param {String} endpoint manager 中的请求方法名
 * @param {Array} args 请求参数
 * @param {Number} [opts.expire] 缓存过期时间(秒), 默认或者为零时不过期
 * @returns {$Promise}
 * @author justanzhu
 */
manager._cacheRequest = function cacheRequest(endpoint, args, opts) {
    caches[endpoint] = caches[endpoint] || {};
    opts = opts || {};

    var cache = caches[endpoint];
    var param = {};
    var cbIndex = 0;
    var expire = opts.expire * 1000;

    if ('function' !== typeof args[0]) {
        param = args[0];
        cbIndex = 1;
    }

    var paramKey = $.param(param);
    var def = $.Deferred();

    args[cbIndex] = appUtil.beforeFn(args[cbIndex] || function () { }, function (data) {
        var isNew = !cache[paramKey];

        //业务回调函数中可能会直接修改 data 对象, 所以每次都需要做一次拷贝
        cache[paramKey] = { data: appUtil.clone(data) };

        if (expire && isNew) {
            cache[paramKey].timer = setTimeout(function () {
                delete cache[paramKey];
            }, expire)
        }

        def.resolve(data);
    });

    if (cache && cache[paramKey] && cache[paramKey].data) {
        args[cbIndex](cache[paramKey].data);
        def.resolve(cache[paramKey].data);
    } else {
        manager[endpoint].apply(manager, args);
    }

    return def.promise();
}

export default manager;